export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	let otherInfo = injured.otherInfo || {}
	let arr = []
	if (
		!this.isPAIC &&
		!this.isCarInsurance &&
		(this.isFirstVisit || this.isResurvey)
	) {
		arr.push({
			label: '是否有其他探视人员来过医院',
			value:
				otherInfo.anotherVisitor == '1'
					? otherInfo.anotherCompany
					: otherInfo.anotherVisitor == '0'
					? '无'
					: '',
		})
	}
	arr.push(
		{
			label: '是否超时',
			value: setting.yesNoMap[order.isTimeout],
		},
		{
			label: `备注${order.isTimeout === '1' ? '（必填）' : '（非必填）'}`,
			value: otherInfo.timeoutDesc,
		}
	)

	const obj = {
		// title: '特殊情况备注',
		title: '其他信息',
		children: arr,
		span: {
			是否有其他探视人员来过医院: 24,
			是否超时: 24,
			'备注（必填）': 24,
			'备注（非必填）': 24,
		},
	}

	return obj
}
